import React, { useCallback } from 'react';
import { ArrowNextIcon } from '../../icons';
import MuiIconButton from '@mui/material/IconButton';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var slate = designTokens.color.gray.slateDefault.value;
var dark = designTokens.color.gray.disabled.value;
var CarouselArrow = function (_a) {
    var direction = _a.direction, disabled = _a.disabled, onClick = _a.onClick, style = _a.style;
    return (React.createElement(MuiIconButton, { disableRipple: true, className: "arrow ".concat(direction, " ").concat(disabled ? 'disabled' : ''), onClick: onClick, disabled: disabled, style: style },
        React.createElement(ArrowNextIcon, { sx: { fill: disabled ? dark : slate }, fontSize: "inherit" })));
};
var Arrows = function (_a) {
    var instanceRef = _a.instanceRef, loop = _a.loop, currentSlide = _a.currentSlide, _b = _a.position, position = _b === void 0 ? 'inside' : _b, offset = _a.offset, onPreviousClick = _a.onPreviousClick, onNextClick = _a.onNextClick;
    var lastSlide = !!instanceRef.current &&
        instanceRef.current.track.details !== null && // this may happen if slides is empty array https://github.com/rcbyr/keen-slider/issues/366
        currentSlide === instanceRef.current.track.details.slides.length - 1;
    var handleRightClick = useCallback(function (e) {
        var _a;
        e.stopPropagation() || ((_a = instanceRef.current) === null || _a === void 0 ? void 0 : _a.next());
        onNextClick === null || onNextClick === void 0 ? void 0 : onNextClick();
    }, [instanceRef]);
    var handleLeftClick = useCallback(function (e) {
        var _a;
        e.stopPropagation() || ((_a = instanceRef.current) === null || _a === void 0 ? void 0 : _a.prev());
        onPreviousClick === null || onPreviousClick === void 0 ? void 0 : onPreviousClick();
    }, [instanceRef]);
    return (React.createElement("div", { className: "arrow-container" }, !!instanceRef.current && (React.createElement(React.Fragment, null,
        React.createElement(CarouselArrow, { direction: "left", onClick: handleLeftClick, disabled: !loop && currentSlide === 0, style: position === 'outside'
                ? { position: 'absolute', left: "-".concat(offset) }
                : undefined }),
        React.createElement(CarouselArrow, { direction: "right", onClick: handleRightClick, disabled: !loop && lastSlide, style: position === 'outside'
                ? { position: 'absolute', right: "-".concat(offset) }
                : undefined })))));
};
export default Arrows;
//# sourceMappingURL=Arrows.js.map